/**
 * Lista viva dos requisitos da senha, marcando o que já foi cumprido.
 *
 * Existe porque regra de composição sem retorno imediato vira tentativa e
 * erro: a pessoa envia, leva "senha inválida", tenta de novo. Aqui ela vê o
 * que falta enquanto digita.
 *
 * Os requisitos vêm de @simpleadm/shared-types — os mesmos que a API aplica.
 * Se divergissem, a tela aprovaria o que o servidor recusa.
 */
import { REQUISITOS_SENHA } from '@simpleadm/shared-types';
import { Check, Circle } from 'lucide-react';

export function RequisitosSenha({ senha }: { senha: string }) {
  return (
    <ul className="mt-1 grid grid-cols-1 gap-x-3 gap-y-0.5 text-[10px] sm:grid-cols-2">
      {REQUISITOS_SENHA.map((r) => {
        const ok = r.atende(senha);
        return (
          <li
            key={r.id}
            className={`flex items-center gap-1 ${
              ok ? 'text-emerald-700' : 'text-muted-foreground'
            }`}
          >
            {ok ? (
              <Check className="h-3 w-3 shrink-0" aria-hidden="true" />
            ) : (
              <Circle className="h-2 w-2 shrink-0" aria-hidden="true" />
            )}
            <span>{r.texto}</span>
            {/* Leitor de tela anuncia a mudança; o ícone sozinho não diz nada. */}
            <span className="sr-only">{ok ? ' — cumprido' : ' — falta'}</span>
          </li>
        );
      })}
    </ul>
  );
}
